<template>
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex justify-content-between align-items-center my-3">
        <div>
          <p class="mb-0">
            Responding to: {{ response.guest.firstName }} {{ response.guest.lastName }} (Score: {{ score }}/{{
              scoreOutOf
            }})
          </p>
        </div>
        <surveys-template-selector
          :preselected="preselectedTemplate"
          @selected="applyTemplate"
          @template-deleted="applyTemplate"
        />
      </div>
      <div class="option-input" style="height: 300px">
        <ckeditor :editor="editor" :config="editorConfig" v-model="respondMessage" @ready="onReady"></ckeditor>
      </div>
    </div>
    <div class="col-md-12">
      <surveys-template-saver :body="respondMessage" @saved="savedTemplate" />
    </div>
    <div class="col-md-12">
      <div class="btn btn-primary pull-right" v-on:click="respond">Respond</div>
    </div>
  </div>
</template>

<script>
import SurveysService from '../../services/surveys-service';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SurveysTemplateSelector from './SurveysTemplateSelector';
import SurveysTemplateSaver from './SurveysTemplateSaver';
export default {
  components: {
    ckeditor: CKEditor.component,
    SurveysTemplateSelector,
    SurveysTemplateSaver,
  },
  props: {
    response: {
      type: Object,
    },
  },
  data() {
    return {
      respondMessage: '',
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ['ImageUpload', 'EasyImage', 'MediaEmbed', 'Highlight'],
        link: {
          addTargetToExternalLinks: true,
        },

        allowedContent: true,
      },
      preselectedTemplate: null,
    };
  },
  computed: {
    score() {
      return this.response.averageFieldsScore / (100 / this.scoreOutOf);
    },
    scoreOutOf() {
      return this.response.outOfFive === 1 ? 5 : 10;
    },
  },
  mounted() {},
  methods: {
    savedTemplate(saved) {
      this.preselectedTemplate = saved;
    },
    async respond() {
      if (!this.respondMessage.trim()) {
        swal("Oops!", "You cannot send an empty response. Please write something before responding.", "error");
        return; 
      }
      const data = await SurveysService.responses.respond(this.response.id, this.respondMessage);

      if (data.error) {
        swal({
          title: 'Could not send response',
          text: data.error,
          type: 'warning',
          showCloseButton: true,
          timer: 10000,
        });
      } else {
        this.$emit('responded', true);
        swal({
          title: 'Response sent',
          text: data.message,
          type: 'success',
          showCloseButton: true,
          timer: 10000,
        });
      }
    },
    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    async applyTemplate(template) {
      if (this.respondMessage == null || this.respondMessage == '' || this.respondMessage == template.body || template?.isFallback) {
        this.respondMessage = template.body;
        return;
      }

      const that = this;

      swal(
        {
          title: 'Are you sure you want to replace the current text with the template?',
          text: 'The action will be applied right away!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#00aef1',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Replace',
        },
        async (result) => {
          if (result) {
            that.respondMessage = template.body;
          }
        },
      );
    },
  },
};
</script>
